import { BasicEvent } from "./BasicEvent";
export class ArbetsorderOperationUpdatedEvent extends BasicEvent {
    arbetsorderId: number;
    arbetsorderRowVersion: string;
    startdatum: string;
    slutdatum: string;
    typ: string;
    maskinlagId?: number;
    entreprenorId?: number;
    operationId: number;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "ArbetsorderOperationUpdatedEvent";
    constructor() {
        super(ArbetsorderOperationUpdatedEvent.$type);
    }
}
